// extracted by mini-css-extract-plugin
export default {"projectsBlock":"Projects_projectsBlock__Vf3zR","projectContainer":"Projects_projectContainer__ho9Xo","projects":"Projects_projects__J-Mai"};